import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { CartContainOnlineItems, CartContainTendersException } from 'src/common/helpers/error-code';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { store } from '../../common/redux/configure-store';
import { ItemListActions } from '../../common/redux/reducers/item-list-reducer';
import { printReceipts } from '../../devices/printer-operations';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { transactionSave } from './service/transaction-save';
import { transactionEnd } from './transaction-end';
import { msvVoidCheck } from './msv-void-check';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

export const saveTransaction = async (): Promise<void> => {
  const transactionId = store.getState().transaction.transactionId;

  if (transactionId) {
    if (getCurrentXLRConfig().supportMsvRewards) {
      await msvVoidCheck();
    }

    try {
      const receipts = await transactionSave(transactionId);
      await printReceipts(receipts).catch(popupMessage);
      await transactionEnd();
      store.dispatch(ItemListActions.setTransactionSaved(true));
    } catch (err) {
      const modalProps: IMessageModal = {
        message: 'SuspendTransactionMessage',
        type: EmeraldDialogTypes.Info,
        hideCancelButton: true,
      };
      switch (err.code) {
        case CartContainOnlineItems:
          modalProps.subMessage = 'SuspendTransactionOnlineItems';
          popupMessage(modalProps);
          break;
        case CartContainTendersException:
          modalProps.subMessage = 'SuspendTransactionPartialTenders';
          popupMessage(modalProps);
          break;
        // Add other error codes here as we get to them
        default:
          popupMessage(err);
          break;
      }
    }
  }
};
